export function handleError ({ vm, error }) {
   console.log(error)
   let errorMessage = null
   if (error) {
      if (typeof error === 'string' || error instanceof  String) {
         errorMessage = error
      }else if (error.response && error.response.data && error.response.data.error) {
         errorMessage = error.response.data.error
      }
   }
   if (errorMessage) {
      vm.$store.commit("errors/setMessage", errorMessage)
   }
   vm.$store.commit("errors/setVisibility", true)
}